import React, { Component } from 'react';
import { map, forEach, sortBy, find, findLast, filter, isEqual } from 'lodash';
import PT from "prop-types";

export const BREAKPOINT_NAMES_ENUM = { MOBILE: "mobile", TABLET: "tablet", SMALL_SCREEN: "small", LARGE_SCREEN: "large" };

export const RESPONSIVE_BREAKPOINTS = { mobile: 655, tablet: 1100, small: 1580, large: 50000 };

export const NBR_COLUMNS_BY_BREAKPOINTS = { mobile: 1, tablet: 2, small: 3, large: 4 };

export const SPACING_BY_BREAKPOINTS = { mobile: 12, tablet: 16, small: 20, large: 20 };

export class ResponsivenessGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: RESPONSIVE_BREAKPOINTS[BREAKPOINT_NAMES_ENUM.LARGE_SCREEN],
            currentBreakpoint: BREAKPOINT_NAMES_ENUM.LARGE_SCREEN
        };

        this.gridRef = React.createRef();
        this.setBreakpointForThisPage = this.setBreakpointForThisPage.bind(this);
        this.createItemsByGroup = this.createItemsByGroup.bind(this);
    }

    componentDidMount() {
        if(this.props.currentBreakpoint === null) {
            window.addEventListener("resize", this.setBreakpointForThisPage, false);
            this.setBreakpointForThisPage();
        }
    }

    componentDidUpdate() {
        if(this.props.refreshSize) 
            this.setBreakpointForThisPage();
    }

    componentWillUnmount() {
        if(this.props.currentBreakpoint === null)
            window.removeEventListener("resize", this.setBreakpointForThisPage, false);
    }

    setBreakpointForThisPage() {
        if(this.props.currentBreakpoint === null) { // Passe pour vérifier si c'est le slider qui se gère tout seule ou gérer à l'extérieur
            const breakpointsConfigs = (this.props.breakpointsConfigs !== null ? this.props.breakpointsConfigs : RESPONSIVE_BREAKPOINTS);
            const curBreakpoint = getBreakpointForContainer(this.gridRef, breakpointsConfigs);

            if(this.state.currentBreakpoint !== curBreakpoint || this.state.width !== this.gridRef.current.clientWidth) 
                this.setState({ currentBreakpoint: curBreakpoint, width: this.gridRef.current.clientWidth });
        }
    }

    createItemsByGroup(items, nbrOfColumns, containerWidth, spacing, isSquare, noInnerSpacing, spacingRightOnly) {
        const allItemsGroups = getSortedItems(items, nbrOfColumns);
        
        return map(allItemsGroups,(itemGroup, rowIndex) => {
            const innerGrid = map(itemGroup, (item, colIndex) => {
                
                let style = { marginRight: 0 };

                // On ajoute de margin dans grid sauf si derniere column
                if(!noInnerSpacing && (spacingRightOnly || colIndex + 1 < itemGroup.length))
                    style.marginRight = spacing;

                // On ajoute de margin dans grid sauf si derniere row
                if(!noInnerSpacing && allItemsGroups.length > 1 && rowIndex + 1 < allItemsGroups.length)
                    style.marginBottom = spacing;

                const size = this.getSize(item.props.isWide, containerWidth, nbrOfColumns, spacing, spacingRightOnly);

                style.width = size.width;
                // Si on veut que les cellules soit carrées
                if(isSquare)
                    style.height = size.height;
                
                return <div key={"col-" + colIndex} className="column" style={style}>
                    {item}
                </div>;
            });

            return <div key={"row-" + rowIndex} style={{width: containerWidth}} className="row">
                {innerGrid}
                <div className="clear"></div>
            </div>;
        });
    }

    getSize(isDouble, containerWidth, numberOfColumn, spacing, spacingRightOnly) {
        const space = (spacingRightOnly ? spacing * numberOfColumn : spacing * (numberOfColumn - 1));

        let squareSize = ((containerWidth - space) / numberOfColumn);
        let width = squareSize;
        if (isDouble) 
            width = (squareSize * 2) + spacing;
        
        return { width: width, height: squareSize };
    }
    
    render() {
        let innerGrid = null;
        
        const nbrColumnsByBreakpointConfigs = (this.props.nbrColumnsByBreakpointConfigs !== null ? this.props.nbrColumnsByBreakpointConfigs : NBR_COLUMNS_BY_BREAKPOINTS);
        let containerWidth;
        if (this.props.width !== null)
            containerWidth = this.props.width;
        else if (this.gridRef.current !== null)
            containerWidth = this.gridRef.current.clientWidth;
        else
            containerWidth = this.state.width;
        
        const curBreakpoint = (this.props.currentBreakpoint !== null ? this.props.currentBreakpoint : this.state.currentBreakpoint);
        
        const outterSpacing = (!this.props.noOutterSpacing ? SPACING_BY_BREAKPOINTS[curBreakpoint] : 0);
        const innerSpacing = (!this.props.noInnerSpacing ? SPACING_BY_BREAKPOINTS[curBreakpoint] : 0);
        
        innerGrid = this.createItemsByGroup(this.props.items, nbrColumnsByBreakpointConfigs[curBreakpoint], containerWidth, innerSpacing, this.props.isSquare, this.props.noInnerSpacing, this.props.spacingRightOnly);

        return (
            <div className="responsiveness-grid" ref={this.gridRef} style={{ marginLeft: outterSpacing, marginTop: outterSpacing, marginRight: outterSpacing, marginBottom: outterSpacing }}>
                {innerGrid}
            </div>
        );
    }
}
ResponsivenessGrid.defaultProps = {
    currentBreakpoint: null,
    width: null,
    breakpointsConfigs: null,
    nbrColumnsByBreakpointConfigs: null,
    isSquare: false,
    noInnerSpacing: false,
    noOutterSpacing: true,
    spacingRightOnly: false,
    refreshSize: false
};

ResponsivenessGrid.propTypes = {
    items: PT.array,
    currentBreakpoint: PT.string,
    breakpointsConfigs: PT.object,
    nbrColumnsByBreakpointConfigs: PT.object,
    width: PT.number,
    onDrag: PT.func,
    isSquare: PT.bool,
    noInnerSpacing: PT.bool,
    noOutterSpacing: PT.bool,
    spacingRightOnly: PT.bool,
    refreshSize: PT.bool
};

function getBreakpointToUse(width, breakpointsConfigs) {
    let currentBreakpoint = BREAKPOINT_NAMES_ENUM.LARGE_SCREEN;
    if(width <= breakpointsConfigs[BREAKPOINT_NAMES_ENUM.MOBILE])
        currentBreakpoint = BREAKPOINT_NAMES_ENUM.MOBILE;
    else if(width <= breakpointsConfigs[BREAKPOINT_NAMES_ENUM.TABLET])
        currentBreakpoint = BREAKPOINT_NAMES_ENUM.TABLET;
    else if(width <= breakpointsConfigs[BREAKPOINT_NAMES_ENUM.SMALL_SCREEN])
        currentBreakpoint = BREAKPOINT_NAMES_ENUM.SMALL_SCREEN;

    return currentBreakpoint;
}

export function getBreakpointForContainer(containerReactRef, breakpointsConfigs) {
    if (containerReactRef.current !== null) 
        return getBreakpointToUse(containerReactRef.current.clientWidth, breakpointsConfigs);
    else
        return RESPONSIVE_BREAKPOINTS.large;
}

export function getItemsByGroup(detailedItems) {
    let allGroups = [];
    let itemsPerGroup = [];
    let page = 1;
    
    forEach(detailedItems, (item) => {
        if(page !== item.page) {
            allGroups.push(itemsPerGroup);
            page = item.page;
            itemsPerGroup = [];
        }
        itemsPerGroup.push(item.item);
    });

    if(itemsPerGroup.length > 0)
        allGroups.push(itemsPerGroup);
    
    return allGroups;
}

function getDetailedItems(items, numberOfitemsByRow) {
    let position = 0;
    let page = 1;
    let detailedItems = map(items, (item) => {
        let hasProblem = false;
        const col = (item.props.isWide ? 2 : 1);
        // wide vaut 2 places
        position = position + col;

        if(position > numberOfitemsByRow) {
            // si c'est un item wide et et qu'on débalance de 1
            // problème d'espace à l'écran on doit deplacer la card à une place plus adéquat
            if((position - col) < numberOfitemsByRow && item.props.isWide) 
                hasProblem = true;

            // Change de page
            if(position > numberOfitemsByRow)
                page = page + 1;
            
            if(position >= numberOfitemsByRow)
                position = col;
        }

        return { page: page, position: position, hasProblem: hasProblem, item: item };
    });

    return detailedItems;
}

// Set tous les champs pour changer les cards en problème de place
function changePositionOfItem(newItem, itemWithProblem) {
    const changePage = newItem.page;
    const changePosition = newItem.position;
    newItem.page = itemWithProblem.page;
    newItem.position = itemWithProblem.position;
    itemWithProblem.page = changePage;
    itemWithProblem.position = changePosition;
}

function getItemsAfterSolveProblems(detailedItems, itemWithProblem) {
    
    // On regarde pour déplacer l'item dans la page précédente
    const itemsBeforePage = filter(detailedItems, ["page", itemWithProblem.page-1]);

    // On attrape le dernier item pas wide et on interchange les 2 items
    let lastItem = findLast(itemsBeforePage, ["item.props.isWide", false]);
    if(lastItem !== undefined) 
        changePositionOfItem(lastItem, itemWithProblem);
    else {
        // On regarde pour déplacer l'item dans une des pages suivantes
        const itemsAllPagesAfter = filter(detailedItems, (item) => item.page >= itemWithProblem.page);

        // On attrape le premier item pas wide et on interchange les 2 items
        let firstItem = find(itemsAllPagesAfter, ["item.props.isWide", false]);
        if(firstItem !== undefined) 
            changePositionOfItem(firstItem, itemWithProblem);
    }
    return sortBy(detailedItems, ['page','position']);
}

export function getSortedItems(items, numberOfitemsByRow, precItemWithProblem) {
    // Ajouter du détails dans les cards
    let newVals = getDetailedItems(items, numberOfitemsByRow);
    // Trouver le premier problème à régler avec les wide cards
    const itemWithProblem = find(newVals, "hasProblem");
    // S'il y a un problème ou que nous sommes pas rendu au bout de la collection et que le probleme est réglable
    if(itemWithProblem !== undefined && !isEqual(itemWithProblem, precItemWithProblem)) {
        newVals = getItemsAfterSolveProblems(newVals, itemWithProblem);
        return getSortedItems(map(newVals, 'item'), numberOfitemsByRow, itemWithProblem);
    }

    return getItemsByGroup(newVals);
}
